import { useIsIntelligems } from "@src/api/user-auths/is-intelligems";
import { useUser } from "@src/api/user-auths/login";

export const useBookDemoLink = (
  baseUrl: string,
  demoSource: string
): string => {
  const user = useUser();
  const isIntelligemsStaff = useIsIntelligems();
  const login =
    isIntelligemsStaff === false && user.isSuccess && user.data.type === "login"
      ? user.data
      : null;

  const url = new URL(baseUrl);
  const fields = {
    firstname: login?.user.firstName ?? undefined,
    lastname: login?.user.lastName ?? undefined,
    email: login?.user.email,
    domain: login?.organization.domain ?? undefined,
    utm_source: "intelligems_app",
    demo_source: demoSource,
  };
  for (const [key, value] of Object.entries(fields)) {
    if (value !== undefined) {
      url.searchParams.set(key, value);
    }
  }
  return url.toString();
};
